import { useEffect } from "react";
import APIManager from "../../managers/APIManager";
import { useLocation } from "react-router";
import { useDispatch, useSelector } from "react-redux";

const SwitchPage = () => {
  const loc = useLocation();
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);

  useEffect(() => {
    const searchParams = new URLSearchParams(loc.search);
    const userId = searchParams.get("id");
    if (userId === auth?.user?.virgulId) {
      window.location = "/";
    }
    APIManager.switchAccount(userId).then((res) => {
      dispatch({ type: "INVALIDATE_SITES" });
      dispatch({
        type: "SWITCH_ACCOUNT",
        payload: {
          status: res.data.user.id ? 1 : 0,
          tokens: res.data.tokens,
          user: res.data.user,
        },
      });
      const referrer = searchParams.get("referrer");
      if (referrer) {
        window.location = referrer;
      } else {
        window.location = "/";
      }
    });
  }, []);
  return (
    <p className="text-lg margin-auto">Switching to requested account...</p>
  );
};

export default SwitchPage;
